import { cn } from '@/lib/utils'

/**
 * Nhóm nút chọn một (kỳ báo cáo, số đơn / doanh thu…). Nền xám nhạt, mục đang
 * chọn nổi lên bằng nền trắng + bóng — cùng kiểu với nút chuyển trên các trang
 * Tổng quan.
 */
export function Segmented<T extends string | number>({
  value,
  onChange,
  options,
  label,
  className,
}: {
  value: T
  onChange: (v: T) => void
  options: ReadonlyArray<readonly [T, string]>
  /** Nhãn cho trình đọc màn hình. */
  label: string
  className?: string
}) {
  return (
    // max-w-full + cuộn ngang trong nhóm: nhiều lựa chọn trên màn hẹp không được đẩy trang rộng ra (trang tràn ngang
    // làm cả khung điện thoại lệch — dock, nút tròn trượt khỏi màn).
    <div
      className={cn('inline-flex max-w-full overflow-x-auto rounded-lg bg-paperSoft p-0.5 text-xs [scrollbar-width:none]', className)}
      role="group"
      aria-label={label}
      data-slot="segmented"
    >
      {options.map(([k, lbl]) => (
        <button
          key={String(k)}
          type="button"
          aria-pressed={value === k}
          onClick={() => onChange(k)}
          className={cn(
            'motion-state min-h-9 shrink-0 whitespace-nowrap rounded-md px-2 font-medium desktop:min-h-7 desktop:px-3',
            value === k ? 'bg-raise text-ink shadow-pop' : 'text-inkSoft hover:text-ink',
          )}
        >
          {lbl}
        </button>
      ))}
    </div>
  )
}

export const PERIOD_OPTIONS = [
  [7, '7 ngày'],
  [14, '14 ngày'],
  [30, '30 ngày'],
  [60, '60 ngày'],
  [90, '90 ngày'],
] as const satisfies ReadonlyArray<readonly [number, string]>
